const BOX = 'flex:none;box-sizing:border-box;height:28px;border-radius:999px;white-space:nowrap;font-family:inherit;font-size:12px;line-height:1';

export const pill = (border = '#C8D4EA') =>
	`${BOX};display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:0 12px;border:1px solid ${border};background:#fff;color:var(--ink-2);outline:none;cursor:pointer`;

export const SELECT = `${BOX};padding:0 10px;border:1px solid #C8D4EA;background:#fff;color:var(--ink-2);outline:none;cursor:pointer`;

export const SEGMENTS = `${BOX};display:flex;align-items:stretch;border:none;box-shadow:inset 0 0 0 1px #C8D4EA;overflow:hidden;background:#fff`;

export const SEGMENT = 'flex:none;height:28px;padding:0 12px;border:none;font-family:inherit;font-size:12px;white-space:nowrap;cursor:pointer';

export const NOTE = `${BOX};display:flex;align-items:center;gap:8px;padding:0 12px;color:var(--ink-2)`;

export const SPLIT = 'flex:none;width:1px;height:20px;background:#DCE4F2';
